(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/dialogs/payment-confirm.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/dialogs/payment-confirm.js');
'use strict';

const {
  getProductName
} = svs.numbergames.productMapping;
class PaymentConfirm extends svs.tur.payment.dialogs.PaymentConfirm {
  constructor(_ref) {
    let {
      productName,
      price,
      accountBalance,
      onConfirm,
      onCancel
    } = _ref;
    super({
      productName,
      price,
      accountBalance,
      isCancelable: false,
      onConfirm,
      onCancel
    });
  }
  getTitle() {
    return "Vill du k\xF6pa en andel f\xF6r ".concat(this.price, " kr<br /> av andelsspelet p\xE5 ").concat(getProductName(this.productName), "?");
  }
  getMessage() {
    return [{
      type: svs.components.dialog.message.TEXT,
      text: 'Summan reserveras från ditt spelkonto och spelet lämnas in när sista andelen är såld.',
      align: svs.components.dialog.message.align.CENTER
    }, {
      type: svs.components.dialog.message.TEXT,
      text: this.getCancelableInfo(),
      align: svs.components.dialog.message.align.CENTER
    }, {
      type: svs.components.dialog.message.TEXT,
      text: "Ditt saldo: ".concat(svs.utils.format.Currency(this.accountBalance), " kr"),
      align: svs.components.dialog.message.align.CENTER
    }];
  }
}
svs.tur.payment.api.jupiter.fractiongames.dialogs.PaymentConfirm = PaymentConfirm;

 })(window);